export const getMedIdType = (dataKey: string | undefined) => {
  switch (dataKey) {
    case "medVaccinations":
      return "vaxid";
    case "medMedicationUsage":
      return "usageid";
    case "medPrescriptions":
      return "presid";
    case "medAllergies":
      return "allergyid";
    case "medMedicalCard":
      return "cardid";
    case "medHearingTests":
      return "hearid";
    default:
      return "";
  }
};
